import { When } from 'react-if'
import { slugs } from '@/constants/slugs'
import { contentfulFaqLocations, useProjectFaqs } from '@/services/FaqService'
import { useLocale } from '@/utils/LocaleUtil'
import { FaqSection } from './FaqSection'
import { HeroSection } from './HeroSection'
import { HowItWorksSection } from './HowItWorksSection'

export const GuildCreateIndexView = () => {
  const { locale } = useLocale()
  const { faqs, loadingProjectFaqs } = useProjectFaqs({
    locale,
    preview: false,
    projectSlug: slugs.angelStudios,
    location: contentfulFaqLocations.guildCreate,
  })

  return (
    <div className="flex w-full flex-col items-center justify-center gap-8 bg-white pb-10 pt-24 lg:gap-20 lg:py-20">
      <HeroSection />
      <HowItWorksSection />
      <When condition={!loadingProjectFaqs}>
        <FaqSection faqs={faqs} />
      </When>
    </div>
  )
}
